var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.customRestOauthNotificationVisible)?_c('section',{class:_vm.$style.notificationWrapper},[_c('NotificationInPage',{attrs:{"actionText":"Got it","notification":_vm.customRestOauthNotification},on:{"action":_vm.handleDismissClick}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }